import { App } from '@capacitor/app';

const V1_PACKAGE_ID = 'io.beyonnex.bxapp';
const V2_PACKAGE_ID = 'io.beyonnex.bxtool';

export function resolveV2PackageId(currentAppId?: string): string {
  if (currentAppId?.startsWith(V1_PACKAGE_ID)) {
    return V2_PACKAGE_ID + currentAppId.slice(V1_PACKAGE_ID.length);
  }
  return V2_PACKAGE_ID;
}

export async function getV2PackageId(): Promise<string> {
  const info = await App.getInfo();
  return resolveV2PackageId(info.id);
}
